/* eslint-disable */

/** unique or primary key constraints on table "argo.material_file_upload_history" */
export enum ArgoMaterialFileUploadHistoryConstraint {
  /** unique or primary key constraint on columns "material_file_upload_history_id" */
  MaterialFileUploadHistoryPkey = 'material_file_upload_history_pkey'
}

/** select columns of table "argo.material_file_upload_history" */
export enum ArgoMaterialFileUploadHistorySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialFileUploadHistoryId = 'material_file_upload_history_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.material_file_upload_history" */
export enum ArgoMaterialFileUploadHistoryUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialFileUploadHistoryId = 'material_file_upload_history_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Status = 'status'
}

